// @flow strict
import type {CustomNoteWritebackAction} from 'src/action-creators/custom-note-writeback';
import type {NodeSchedule} from 'src/types/node-schedule';
import {
  RECEIVE_CUSTOM_NOTE_WRITEBACK_INFO,
  UPDATE_CUSTOM_NOTE_WRITEBACK_INFO,
  UPDATE_NODE_SCHEDULE,
  RESET_CUSTOM_NOTE_WRITEBACK_STATE,
} from 'src/action-creators/custom-note-writeback';
import {getDefaultNodeScheduleState} from 'src/utils/node-schedule';


export type CustomNoteWritebackState = {
  note: string,
  external_entity_id: ?string,
  noteAction: ?(string | number),
  external_entity_type: ?string,
  ...NodeSchedule,
};

const initialState = {
  note: ``,
  external_entity_id: null,
  noteAction: null,
  external_entity_type: null,
  ...getDefaultNodeScheduleState({}),
};

export default (
  state: CustomNoteWritebackState = initialState,
  action: CustomNoteWritebackAction,
): CustomNoteWritebackState => {
  switch (action.type) {
    case UPDATE_CUSTOM_NOTE_WRITEBACK_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case RECEIVE_CUSTOM_NOTE_WRITEBACK_INFO:
      return {
        ...state,
        ...action.payload,
      };
    case UPDATE_NODE_SCHEDULE:
      return {
        ...state,
        ...action.payload,
      };
    case RESET_CUSTOM_NOTE_WRITEBACK_STATE:
      return {...initialState};
  }
  return state;
};
